<template>
    <v-container class="grey darken-2 ">
        <v-row>
            <v-col cols="12" sm="12" v-for="index3 in 1" :key="index3">
                <v-card>
                    <v-card-title style="text-align:center" class="red darken-4">
                        <h1 class="white--text">
                            December Festive Promotion
                        </h1>
                    </v-card-title>
                    <v-row class="mt-4">
                        <v-col md="6" sm="12">
                            <v-row>
                                <v-col sm="3" v-for="index2 in stickers" :key="index2">
                                    <v-avatar style="border-style: solid; border-width: 1px; border-color: dimgray;"
                                        size="80">
                                        <img src="@/assets/Media/WestpackLogo.png" alt="Johns">
                                    </v-avatar>
                                </v-col>
                                <v-col sm="3" v-for="index4 in (totalStickers - stickers)" :key="index4">
                                    <v-avatar style="border-style: solid; border-width: 1px;" size="80" color="grey">
                                        <span class="white--text text-h5">{{index4 + stickers}}</span>
                                    </v-avatar>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col style="text-align: center;" md="6" sm="12">
                            <v-img max-width="300" contain src="@/assets/Media/Promotions/tempPriceList.jpg">
                            </v-img>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'Home',
        components: {

        },
        data: () => ({
            stickers: 4,
            totalStickers: 15
        }),
        methods: {

        }
    }
</script>
<style>
    .border {
        border-color: dimgray;
    }
</style>